import { shape, string, number } from 'prop-types';
import React from 'react';
import BaseTeaser from 'oxygen-lib-ui/components/Teaser';
import { getLinkProps } from 'util/link';
import { truncate } from 'util/string';
import { getFormattedDate } from 'oxygen-lib-ui/helpers/date';
import { updateTeaserAttributes } from './helper';

// this format string uses the timezone lib format
const PROMOTED_DATE_FORMAT = '%Y-%m-%d %H:%M %z';

export const TRUNCATED_VARIANTS = ['everydayGrid'];

export const TRUNCATED_HEADLINE_LENGTH = 80;

function Teaser(props) {
  const {
    url,
    gtmAttrs: gtmBaseAttrs,
    headline: baseHeadline,
    variant,
    promotedAt,
    idx,
    tags,
    teaserAttributes: baseTeaserAttributes
  } = props;

  const link = getLinkProps(url);
  const teaserAttributes = updateTeaserAttributes(baseTeaserAttributes, {
    tags,
    url
  });

  const headline = TRUNCATED_VARIANTS.includes(variant)
    ? truncate(baseHeadline, TRUNCATED_HEADLINE_LENGTH)
    : baseHeadline;

  const gtmAttrs = {
    ...gtmBaseAttrs,
    // idx is an int and 0 is falsy, so check for undefined
    ...(idx !== undefined && {
      'data-gtm-teaser-slot': idx + 1
    }),
    ...(promotedAt !== undefined && {
      'data-gtm-teaser-promoted-at': getFormattedDate(
        promotedAt,
        PROMOTED_DATE_FORMAT
      )
    })
  };

  return (
    <BaseTeaser
      {...props}
      headline={headline}
      teaserAttributes={teaserAttributes}
      gtmAttrs={gtmAttrs}
      link={link}
    />
  );
}

Teaser.propTypes = {
  url: string.isRequired,
  gtmAttrs: shape({}),
  idx: number,
  ...BaseTeaser.propTypes
};

Teaser.defaultProps = {
  gtmAttrs: undefined,
  idx: undefined,
  ...BaseTeaser.defaultProps
};

export default Teaser;
